import { render, staticRenderFns } from "./content.vue?vue&type=template&id=355af65e&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=355af65e&prod&lang=scss&scoped=true"
import style1 from "./content.vue?vue&type=style&index=1&id=355af65e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355af65e",
  null
  
)

export default component.exports